import { appConfig } from "../../config/config";
import { AuthUserTy, LoginUserTy } from "../../config/types";
import { handleError } from "../../utils/handleError";
import { UseCreateForm } from "../../utils/useCreateForm";
import { authApiClient } from "../apiClient";
import CookieService from "../CookieService";

export const loginUser = async (form: LoginUserTy): Promise<AuthUserTy> => {
  let authUser: AuthUserTy = {
    token_type: "",
    isSuccess: false,
    
  };

  try {
    const formData = UseCreateForm(form);

    const res = await authApiClient.post("auth/authenticate", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    if (res.status === 200) {
      const data = res.data;
      CookieService.setCookie(appConfig.authAccessToken, data.access_token);
      authUser.token_type = data.token_type;
      authUser.isSuccess = true;
    }
  } catch (error) {
    authUser.data=(error as any)?.response?.data.data
    const errorMessage = handleError(error);
    authUser.message = errorMessage.message;
  }

  return authUser;
};
